export default __webpack_public_path__ + "4c283dcbc77fbad5aba2e876fca390b8.png";